export default __webpack_public_path__ + "static/media/badge-2.d7ed1cec.png";